/** Os quatro destinos da navegação inferior, e qual deles está aceso.
 *
 * Fora do `App` pelo mesmo motivo de `itensDoMais`: qual destino está ativo é
 * **decisão** — depende da tela e de haver folha aberta por cima —, e é a parte
 * que erra. Marcar dois ao mesmo tempo, ou nenhum, não quebra nada e dá à
 * pessoa a informação errada sobre onde ela está.
 */

import type { DestinoDaNavegacao } from "@/shared/ui/NavegacaoInferior";

export type TelaDeConteudo = "funil" | "agenda" | "arquivo";

export interface AcoesDoCelular {
  aoIrPara: (tela: TelaDeConteudo) => void;
  aoAbrirMais: () => void;
}

export function destinosDoCelular(
  tela: TelaDeConteudo,
  /** Alguma folha está aberta por cima do conteúdo? Se sim, quem manda é
   * "Mais": é de lá que toda folha é alcançada no celular, e deixar o destino
   * de baixo aceso diria que a pessoa está no funil enquanto lê a auditoria. */
  folhaAberta: boolean,
  acoes: AcoesDoCelular,
): DestinoDaNavegacao[] {
  const noConteudo = (alvo: TelaDeConteudo) => !folhaAberta && tela === alvo;

  return [
    {
      rotulo: "Funil",
      icone: "▦",
      ativo: noConteudo("funil"),
      aoAcionar: () => {
        acoes.aoIrPara("funil");
      },
    },
    // Agenda antes de Fechadas: uma responde "o que faço hoje", a outra "o que
    // aconteceu". A primeira é diária — a mesma ordem da barra superior.
    {
      rotulo: "Agenda",
      icone: "▤",
      ativo: noConteudo("agenda"),
      aoAcionar: () => {
        acoes.aoIrPara("agenda");
      },
    },
    {
      rotulo: "Fechadas",
      icone: "✓",
      ativo: noConteudo("arquivo"),
      aoAcionar: () => {
        acoes.aoIrPara("arquivo");
      },
    },
    { rotulo: "Mais", icone: "☰", ativo: folhaAberta, aoAcionar: acoes.aoAbrirMais },
  ];
}
